import classnames from 'classnames/bind';
import { ErrorIcon } from 'tuui';
import {
    TrackingBadgeTooltipComponent,
    useTrackingBadgeAndTooltip,
} from '../../../../modules/tracking/hooks/useTrackingBadgeAndTooltip';
import styles from './TrackingBadge.module.scss';

const classNameBuilder = classnames.bind(styles);

export const TrackingBadge = () => {
    const { showBadgeAndTooltip, badgeType, tooltipContent, pixelStatus } = useTrackingBadgeAndTooltip();

    if (!showBadgeAndTooltip) {
        return null;
    }

    return (
        <>
            <ErrorIcon
                style={{ fontSize: 'medium' }}
                className={classNameBuilder(styles['alert-icon'], styles[badgeType])}
            />
            <TrackingBadgeTooltipComponent
                badgeType={badgeType}
                tooltipContent={tooltipContent}
                pixelStatus={pixelStatus}
            />
        </>
    );
};
